import { render, staticRenderFns } from "./detail-new-v2.vue?vue&type=template&id=e3f5a5e2&scoped=true&"
import script from "./detail-new-v2.vue?vue&type=script&lang=js&"
export * from "./detail-new-v2.vue?vue&type=script&lang=js&"
import style0 from "./detail-new-v2.vue?vue&type=style&index=0&id=e3f5a5e2&prod&scoped=true&lang=css&"
import style1 from "./detail-new-v2.vue?vue&type=style&index=1&id=e3f5a5e2&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3f5a5e2",
  null
  
)

export default component.exports